import React from "react";
import Swiper from "react-id-swiper";
// SCSS
import "./blog.scss";
import "swiper/css/swiper.css";
// Assets
import Preview01 from "../../assets/blog/story01/preview.webp";
import Preview02 from "../../assets/blog/story02/preview.webp";
import Preview03 from "../../assets/blog/story03/preview.webp";
import Preview04 from "../../assets/blog/story04/preview.webp";
import Preview05 from "../../assets/blog/story05/preview.webp";
import Preview06 from "../../assets/blog/story06/preview.webp";
// Components
import Title from "../ui-components/title/title";
import BlogBox from "./blogBox";

class Blog extends React.Component {
  state = {
    // LIST ARRAY OF BLOG STORIES
    stories: [
      {
        image: Preview01,
        id: "1",
        title: "Bodas 💍",
        description: "Celebraciones únicas que transforman sueños en realidad con una planificación impecable.",
        date: " ",
      },
      {
        image: Preview02,
        id: "2",
        title: "XV Años 🎉",
        description: "Momentos inolvidables con detalles personalizados para una celebración especial",
        date: " ",
      },
      {
        image: Preview03,
        id: "3",
        title: "Conferencias y Congresos 🎤",
        description: "Organización profesional para eventos de negocios, capacitaciones y encuentros empresariales.",
        date: " ",
      },
      {
        image: Preview04,
        id: "4",
        title: "Ferias y Exposiciones 🏢",
        description: "Coordinación estratégica para eventos comerciales, lanzamientos de productos y networking.",
        date: " ",
      },
      {
        image: Preview05,
        id: "5",
        title: "Ceremonias Religiosas ⛪",
        description: "Desde bautizos hasta aniversarios religiosos, cada evento con el respeto y la solemnidad que merece.",
        date: " ",
      },
      {
        image: Preview06,
        id: "6",
        title: "Festividades Culturales 🎭",
        description: "Eventos que resaltan la tradición y el valor cultural, desde festivales hasta celebraciones temáticas",
        date: " ",
      },
    ],
  };

  render() {
    // BLOG STORIES RENDER
    let storiesRender = null;
    if (this.state.stories) {
      storiesRender = this.state.stories.map((story) => (
        <div key={story.id}>
          <BlogBox article={story} />
        </div>
      ));
    }
    // OPTIONS FOR BLOG SLIDER
    const params = {
      grabCursor: true,
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
      autoplay: {
        delay: 3000, // 3 seconds per slide
        disableOnInteraction: false, // Keeps autoplay working even after user interacts
      },
      breakpoints: {
        1200: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        640: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        320: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
      },
    };

    return (
      <div className="blog" id="blog">
        <div className="wrapper">
          <Title title="TIPOS DE EVENTOS" />
          <p className="font12">
          Nos especializamos en la planificación y coordinación de eventos sociales, corporativos y religiosos. Desde celebraciones íntimas hasta encuentros empresariales, nos encargamos de cada detalle para que tu evento sea único e inolvidable.
          </p>
          <div className="padding30">
            <Swiper {...params}>{storiesRender}</Swiper>
          </div>
        </div>
      </div>
    );
  }
}

export default Blog;
